import StockVarianceProcess from "@/pages/receiveGoods/StockVarianceProcess/index.vue";
import StockVarianceProcessDetail from "@/pages/receiveGoods/StockVarianceProcess/StockVarianceProcessDetail.vue";
import NotDataPackageList from "@/pages/supply/NotDataPackageList/index.vue";
import SupplyPackageList from "@/pages/supply/SupplyPackageList.vue";

export default [
  {
    path: "supply/not-data-package-list", // 无数据包裹列表
    name: "NotDataPackageList",
    component: () => NotDataPackageList,
    meta: {
      title: "无数据包裹列表",
    },
  },
  {
    path: "supply/package-list", // 档口收包记录列表
    name: "SupplyPackageList",
    component: SupplyPackageList,
    meta: {
      title: "档口收包记录列表",
    },
  },
  {
    path: "receive-goods/stock-variance-process", // 入库差异处理
    name: "StockVarianceProcess",
    component: StockVarianceProcess,
    meta: {
      title: "入库差异处理",
    },
  },
  {
    path: "receive-goods/stock-variance-process-detail/:id", // 代采订单详情
    name: "StockVarianceProcess",
    component: StockVarianceProcessDetail,
    meta: {
      title: "入库差异处理详情",
    },
  },
];



// WEBPACK FOOTER //
// ./src/router/routes/receiveGoods.js